import styled from '@emotion/styled';

import { css } from '@emotion/react';
import {
    gutterSizes,
    colors,
    colorVariables,
    fontWeights,
    fontSizes,
    mediaQuery,
    breakpoints,
} from '@gumtree/ui-library/src/base/theme';

export const Container = styled.div`
    padding: ${gutterSizes.small} ${gutterSizes.medium} ${gutterSizes.medium};

    & .seller-phone {
        padding: ${gutterSizes.small} 0 ${gutterSizes.medium} 0;
    }

    & .seller-stats-item {
        padding-bottom: ${gutterSizes.base};
        padding-left: ${gutterSizes.medium};
    }

    & .seller-contact {
        width: 100%;
    }

    .breeder-ribbon {
        position: relative;
        top: 0;
        left: 0;
        width: 115px;
        text-transform: none;
        font-size: ${fontSizes.small};
        font-weight: ${fontWeights.bold};
        height: 24px;
        border-top-left-radius: ${gutterSizes.small};
        border-bottom-left-radius: ${gutterSizes.small};
        background: ${colors.linkVisited};
        line-height: 24px;

        &::before {
            border-top: 12px solid ${colors.linkVisited};
            border-top-right-radius: 4px;
        }
        &::after {
            border-bottom: 12px solid ${colors.linkVisited};
            border-bottom-right-radius: ${gutterSizes.small};
        }
    }

    ${mediaQuery.until(breakpoints.small)} {
        padding: ${gutterSizes.small} ${gutterSizes.medium} 0;
    }
`;

export const ContainerNew = styled.div`
    margin-top: ${gutterSizes.xxlarge};
    padding: 0 ${gutterSizes.xlarge} ${gutterSizes.xlarge};

    & .seller-phone {
        padding: ${gutterSizes.small} 0 ${gutterSizes.medium} 0;
    }

    & .seller-stats-item {
        padding-bottom: ${gutterSizes.base};
        padding-left: ${gutterSizes.medium};
    }

    & .seller-contact {
        width: 100%;
    }

    ${mediaQuery.until(breakpoints.small)} {
        padding: ${gutterSizes.small} ${gutterSizes.medium} 0;
    }
    ${mediaQuery.until(breakpoints.medium)} {
        display: none
    }
`;

export const ContactName = styled.h4<{ hasButtons: boolean }>`
    padding-top: ${gutterSizes.medium};
    padding-bottom: ${({ hasButtons }) => (hasButtons ? gutterSizes.large : gutterSizes.base)};
    margin: 0;
    &[data-q='seller-name'] {
        color: ${colors.navy};
    }
`;

export const WebsiteUrlTruncation = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

interface ButtonGroupProps {
    canCall: boolean;
    canSms: boolean;
    canOffer: boolean;
    isMotorsCTATask1?: boolean;
}

export const ButtonGroup = styled.div<ButtonGroupProps>`
    display: grid;
    grid-gap: ${gutterSizes.base};
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));

    /* stylelint-disable */
    ${({ canCall, canSms, canOffer, isMotorsCTATask1 }) =>
        (canCall &&
            canSms &&
            canOffer &&
            css`
                grid-template-areas:
                    'reply-email reply-phone'
                    'reply-sms make-offer';
            `) ||
        (canCall &&
            canOffer &&
            css`
                grid-template-areas:
                    'reply-email reply-phone'
                    'make-offer make-offer';
            `) ||
        (canCall &&
            canSms &&
            css`
                grid-template-areas:
                    'reply-email reply-email'
                    'reply-phone reply-sms';
            `) ||
        (canCall &&
            isMotorsCTATask1 &&
            css`
                grid-auto-flow: dense;
                grid-template-areas: 'reply-phone reply-email';
            `) ||
        (canCall &&
            css`
                grid-template-areas: 'reply-email reply-phone';
            `) ||
        (canOffer &&
            css`
                grid-template-areas: 'reply-email make-offer';
            `) ||
        css`
            grid-template-areas: 'reply-email reply-email';
        `}/* stylelint-enable */
`;

export const IconInformation = styled.p<{ isEmailVerified?: boolean }>`
    display: flex;
    align-items: center;
    color: ${colorVariables.textPrimary};
    padding: 0;
    margin: ${gutterSizes.medium} 0;

    svg {
        padding-right: ${gutterSizes.base};
    }

    span {
        font-weight: ${fontWeights.lightBold};
        padding-left: ${gutterSizes.small};
    }

    ${({ isEmailVerified }) =>
        isEmailVerified &&
        css`
            margin: ${gutterSizes.medium} 0 0 0;

            + .seller-phone {
                margin-top: ${gutterSizes.medium};
            }

            + ${ButtonGroup} {
                margin-top: ${gutterSizes.large};
            }
        `}
`;
